<template>
  <b-modal ref="modal" class="modal-removal" centered @hidden="onModalHidden">
    <template slot="modal-header">
      <h1>{{ Translations.sections.tracks.removal.title }}</h1>
    </template>
    <template>
      <transition name="fade" mode="out-in">
        <WaitingBlock
          v-if="modalState.isLoadingTracks===true || modalState.isDeletingTracks===true"
        ></WaitingBlock>
      </transition>
      <transition name="fade" mode="out-in">
        <div v-if="!modalState.isLoadingTracks && deleteResponse == null">
          <div v-if="modalState.hasLoadingError" class="text-danger">
            <div v-for="error in trackData.errors">{{error.message}}</div>
          </div>
          <div v-else-if="trackUids == null || trackUids.length == 0">No Track Selected</div>
          <b-form class="form" v-else>
            <p v-if="trackUids.length==1">{{Translations.sections.tracks.removal.textSingle }}</p>
            <p v-else-if="trackUids.length>1">{{Translations.sections.tracks.removal.textMultiple }}</p>
            <div class="table-container">
              <table class="w-100">
                <thead class="border-bottom">
                  <tr>
                    <th></th>
                    <th>Title</th>
                    <th>Box&nbsp;#</th>
                  </tr>
                </thead>
                <tr v-for="track in trackData">
                  <!--<td><DurationText :duration="track.duration"></DurationText></td>-->
                  <td class="pr-2">
                    <i
                      :title="track.statistics.boxCount == 0?'':'Still linked to '+track.statistics.boxCount+' box(es)'"
                      :class="['fas', {'fa-check':track.statistics.boxCount == 0}, {'fa-exclamation-circle':track.statistics.boxCount > 0}]"
                    ></i>
                  </td>
                  <td class="py-2">
                    <div>{{ track.title }}</div>
                    <div class="small">
                      <ArtistBadgeList
                        :artists="track.artists"
                        :simpleText="true"
                        :showHidden="false"
                      ></ArtistBadgeList>
                    </div>
                  </td>
                  <td
                    :class="[{'text-danger':track.statistics.boxCount > 0}]"
                  >{{track.statistics.boxCount}}</td>
                </tr>

<!--                <tfoot v-if="trackStats.notRemovable > 0 || trackStats.removable > 0" class="border-top">-->
<!--                  <tr v-if="trackStats.notRemovable > 0">-->
<!--                    <td>-->
<!--                      <span>-->
<!--                        <i :class="['fas', 'fa-exclamation-circle']"></i>-->
<!--                      </span>-->
<!--                    </td>-->
<!--                    <td class="status py-2">-->
<!--                      <span>{{trackStats.notRemovable}} track(s) not removable</span>-->
<!--                    </td>-->
<!--                  </tr>-->
<!--                  <tr v-if="trackStats.removable > 0">-->
<!--                    <td>-->
<!--                      <span>-->
<!--                        <i :class="['fas', 'fa-check']"></i>-->
<!--                      </span>-->
<!--                    </td>-->
<!--                    <td class="status py-2">-->
<!--                      <span>{{trackStats.removable}} track(s) removable</span>-->
<!--                    </td>-->
<!--                  </tr>-->
<!--                </tfoot>-->
              </table>
            </div>
          </b-form>
        </div>
        <div v-else-if="!modalState.isDeletingTracks && deleteResponse != null">
            <div v-if="modalState.hasDeleteError">
              <div
                class="text-danger"
                v-for="error in deleteResponse.errors"
                :key="error.errorMessage || error.message"
              >{{ error.errorMessage || error.message }}</div>
            </div>
            <div v-else-if="deleteResponse.dataItem != null">
              {{ Object.keys(deleteResponse.dataItem).length }} deleted track(s)
            </div>
          </div>
      </transition>
    </template>
    <template slot="modal-footer">
      <div>
        <Button
          v-show="showCancelBtn"
          :empty="true"
          class="close-popup"
          @click.prevent="cancelModal"
        >{{ Translations.buttons.cancel }}</Button>
      </div>
      <Button
        :empty="false"
        class="validate"
        v-if="deleteResponse ==null &&
        !modalState.isLoadingTracks &&
        trackUids != null &&
        trackUids.length > 0 &&
        trackStats.notRemovable > 0 &&
        currentStation.uid==='fb6e2546-94ca-4c7f-b089-9630cb5a1f1d' &&
        currentRouteName === 'PendingHome'"
        @click.prevent="removeTracks(true)"
      >{{ Translations.buttons.deleteAndUnliked }}</Button>
      <Button
          :empty="false"
          class="validate"
          v-if="deleteResponse ==null && !modalState.isLoadingTracks &&
          trackUids != null && trackUids.length > 0 && trackStats.removable > 0 && trackStats.notRemovable === 0"
          @click.prevent="removeTracks(false)"
      >{{ Translations.buttons.delete }}</Button>
      <Button
        :empty="false"
        class="validate"
        v-if="deleteResponse !=null"
        @click.prevent="cancelModal()"
      >{{ Translations.buttons.close }}</Button>
    </template>
  </b-modal>
</template>

<script>
import Button from "@/components/common/Button";
import Bootstrap from "bootstrap-vue";
import store from "@/store";
import router from "@/router";
import Translations from "@/store/translations";
import EventBus from "@/eventbus";
import Apis from "@/apis/index";
import Portlet from "@/components/common/Portlet.vue";
import { HTTP } from "@/utils/http";
import { mapState } from "vuex";
import WaitingBlock from "@/components/common/WaitingBlock";

import ArtistBadgeList from "@/components/common/ArtistBadgeList";
import TextInput from "@/components/common/TextInput";
import DurationText from "@/components/common/DurationText";

export default {
  name: "TrackRemovalCard",
  store,
  components: {
    Portlet,
    Bootstrap,
    Button,
    WaitingBlock,
    ArtistBadgeList,
    TextInput,
    DurationText
  },
  computed: {
    ...mapState(["currentStation", "editedBox"]),
    Translations: function() {
      return Translations;
    },
    errorMessages: function(inputName) {
      if (this.creationResponse == null || this.creationResponse.errors == null)
        return [];
    },
    trackStats() {
      var removable =
        !this.modalState.hasLoadingError && this.trackData != null
          ? this.trackData.filter(tr => tr.statistics.boxCount == 0)
          : [];
      var notRemovable =
        !this.modalState.hasLoadingError && this.trackData != null
          ? this.trackData.filter(tr => tr.statistics.boxCount > 0)
          : [];

      return {
        removableTracks: removable,
        removable: removable.length,
        notRemovableTracks: notRemovable,
        notRemovable: notRemovable.length
      };
    },
    removedTrackData() {
      var tmp =
        this.modalState.hasDeleteError || this.deleteResponse == null
          ? {}
          : this.deleteResponse.dataItem || {};

      return {
        keys: Object.keys(tmp) || [],
        values: Object.values(tmp) || []
      };
    },
    currentRouteName() {
      return this.$route.name;
    }
  },
  watch: {
    currentStation: function() {
      console.log("station changed");
    },
    trackUids: function() {
      this.loadTracks();
      this.$refs["modal"].show();
    }
  },
  mounted() {
    this.loadTracks();
  },
  data() {
    return {
      modalState: {
        show: true,
        visible: true,
        isLoadingTracks: true,
        isDeletingTracks: false,
        hasDeleteError: false,
        hasLoadingError: false
      },
      trackUids: null,
      trackData: null,
      deleteResponse: null,
      showCancelBtn: true
    };
  },
  methods: {
    editForTracks(tracks) {
      if (tracks != null && tracks.length > 0) {
        this.trackUids = tracks.map(tr => tr.uid);
      }
      this.$refs["modal"].show();
    },
    removeTracks(shouldUnlink) {
      console.log("Remove tracks", this.trackStats.removableTracks);
      try {
        if (
          this.currentStation != null &&
          this.trackStats.removableTracks.length >= 0
        ) {
          this.modalState.isDeletingTracks = true;
          HTTP.post(Apis.library.tracks.update.remove, {
            stationUid: this.currentStation.uid,
            trackUids: this.trackData.map(tr => tr.uid),
            shouldUnlink: shouldUnlink ? shouldUnlink : false,
          })
            .then(this.onTracksDeleted, this.onTracksDeleteError)
            .then(this.onTracksDeleteComplete);
        } else {
          this.modalState.isDeletingTracks = false;
        }
      } catch (e) {
        alert(e);
        this.modalState.isDeletingTracks = false;
      }
    },
    resetData() {
      this.modalState.isLoadingTracks = true;
      this.modalState.isDeletingTracks = this.modalState.hasDeleteError = this.modalState.hasLoadingError = false;
      this.deleteResponse = this.trackData = null;
      this.showCancelBtn = true;
    },
    loadTracks() {
      this.resetData();
      try {
        if (
          this.currentStation != null &&
          this.trackUids != null &&
          this.trackUids.length > 0
        ) {
          this.modalState.isLoadingTracks = true;
          HTTP.post(Apis.library.tracks.removalData, {
            stationUid: this.currentStation.uid,
            trackUids: this.trackUids
          })
            .then(this.onTrackLoaded, this.onTrackLoadError)
            .then(this.onTrackLoadComplete);
            
            
        } else {
          this.modalState.isLoadingTracks = false;
        }
      } catch (e) {
        alert(e);
        this.modalState.isLoadingTracks = false;
      }
    },
    //=================================================================================================
    onTrackLoaded(response) {
      var data = response.data.dataItem;
      if (data != null) {
        data = data.sort(function(a, b) {
          return (a.statistics.boxCount || 0) - (b.statistics.boxCount || 0);
        });
      }
      this.trackData = data;
      this.$store.commit('tracks/isDeletedTrack', false)
    },
    onTrackLoadError(error) {
      this.modalState.hasLoadingError = true;
      this.trackData = error.response.data;
    },
    onTrackLoadComplete(response) {
      this.modalState.isLoadingTracks = false;
    },
    //=================================================================================================
    onTracksDeleted(response) {
      this.$store.commit('tracks/isDeletedTrack', true)
      const data = response.data;
      this.deleteResponse = data;
      if(response.status === 200){
        this.$store.dispatch('Toasts/addToast', {
          title: 'Success',
          autoHideDelay: 1000,
          message: 'Removed successfully',
          type: 'success'
        });
      }
      this.showCancelBtn = false;
    },
    onTracksDeleteError(error) {
      this.modalState.hasDeleteError = true;
      this.deleteResponse = error;
      this.showCancelBtn = false;
    },
    onTracksDeleteComplete(response) {
      EventBus.$emit("reFreshLeftMenu")
      this.modalState.isDeletingTracks = false;
      this.showCancelBtn = false;
    },
    //=================================================================================================
    cancelModal() {
      this.$refs["modal"].hide();
    },
    onModalHidden() {
      EventBus.$emit("onTracksDeleteEnded", this.removedTrackData.keys);
      this.resetData();
    }
  }
};
</script>

<style scoped>
</style>
